import { render, staticRenderFns } from "./createIncresosPdv.vue?vue&type=template&id=36c8b0ba&scoped=true&"
import script from "./createIncresosPdv.vue?vue&type=script&lang=js&"
export * from "./createIncresosPdv.vue?vue&type=script&lang=js&"
import style0 from "./createIncresosPdv.vue?vue&type=style&index=0&id=36c8b0ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c8b0ba",
  null
  
)

export default component.exports